'use client';

import { useState } from 'react';

interface TabProps {
	tabs: string[];
	onTabChange?: (activeTab: string) => void;
}

export const LeaguesTabs = ({ tabs, onTabChange }: TabProps) => {
	const [activeTab, setActiveTab] = useState<string>(tabs.at(0) || '');

	const handleTabClick = (tab: string) => {
		setActiveTab(tab);
		if (onTabChange) {
			onTabChange(tab);
		}
	};

	return (
		<div className="flex w-full items-center justify-between rounded-lg bg-purple-100 p-2">
			{tabs.map((tab) => (
				<button
					key={tab}
					onClick={() => handleTabClick(tab)}
					className={`flex-1 rounded-lg py-2 text-center transition-colors duration-200 ${
						activeTab === tab ? 'bg-purple-600 text-white' : 'bg-transparent text-gray-700'
					}`}
				>
					{tab}
				</button>
			))}
		</div>
	);
};
